module.exports = __webpack_public_path__ + "static/media/Group_3650.85cdf2b5.png";